import AuthRegistrationPage from "@/components/AuthRegistrationPage";

export default function Register() {
  return <AuthRegistrationPage variant="player" />;
}
